export default () => ({
  signatures: [],
  numberOfPages: 1,
});
